import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import './PayRunTriggerScreen.css'; // Optional for styling
import { triggerPayRun } from './PayrunService';
import { useAuth } from '../AuthProvider';

const PayRunTriggerScreen = (props) => {
  const [frequency, setFrequency] = useState('Fortnightly');
  const [payPeriodStart, setPayPeriodStart] = useState(new Date());
  const [payPeriodEnd, setPayPeriodEnd] = useState(new Date());
  const [payDate, setPayDate] = useState(new Date());
  const authContext=useAuth();
  const handleTrigger = () => {
    alert(`Pay Run Triggered:
Frequency: ${frequency}
Pay Period: ${format(payPeriodStart, 'yyyy-MM-dd')} to ${format(payPeriodEnd, 'yyyy-MM-dd')}
Pay Date: ${format(payDate, 'yyyy-MM-dd')}`);
triggerPayRun(props.additionalUserInfo.companyId, format(payPeriodStart, 'yyyy-MM-dd'), format(payPeriodEnd, 'yyyy-MM-dd'), format(payDate, 'yyyy-MM-dd'),authContext.token);
    // TODO: Replace with backend API call
    // axios.post('/api/payrun', { frequency, payPeriodStart, payPeriodEnd, payDate });
  };

  return (
    <div className="trigger-payrun-container">
      <h2>Trigger Pay Run</h2>

      <div className="form-group">
        <label>Pay Frequency</label>
        <select value={frequency} onChange={(e) => setFrequency(e.target.value)}>
          <option value="Weekly">Weekly</option>
          <option value="Fortnightly">Fortnightly</option>
          <option value="Monthly">Monthly</option>
        </select>
      </div>

      <div className="form-group">
        <label>Pay Period Start</label>
        <DatePicker
          selected={payPeriodStart}
          onChange={date => setPayPeriodStart(date)}
          dateFormat="yyyy-MM-dd"
        />
      </div>

      <div className="form-group">
        <label>Pay Period End</label>
        <DatePicker
          selected={payPeriodEnd}
          onChange={date => setPayPeriodEnd(date)}
          dateFormat="yyyy-MM-dd"
        />
      </div>

      <div className="form-group">
        <label>Pay Date</label>
        <DatePicker
          selected={payDate}
          onChange={date => setPayDate(date)}
          dateFormat="yyyy-MM-dd"
        />
      </div>

      <button onClick={handleTrigger} className="trigger-button">
        Trigger Pay Run
      </button>
    </div>
  );
};

export default PayRunTriggerScreen;
